export class CloseHoldingPageModel {
    asofdate : any;    
    topBottomFlag:any =true; 
    currencyCode: any;   
}